(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Autoplay = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Autoplay = exports.Autoplay = /*#__PURE__*/function () {
  function Autoplay(position) {
    _classCallCheck(this, Autoplay);
    this.position = position;
    this.intervalId = null;
    this.seconds = 5;
  }
  return _createClass(Autoplay, [{
    key: "enable",
    value: function enable() {
      var _this = this;
      this.intervalId = window.setInterval(function () {
        return _this.position.moveToNext();
      }, this.seconds * 1000);
    }
  }, {
    key: "disable",
    value: function disable() {
      if (this.intervalId === null) {
        return;
      }
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }]);
}();

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dot = void 0;
var _selectors = require("./selectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Dot = exports.Dot = /*#__PURE__*/function () {
  function Dot(containerEl, position, offset) {
    var _this = this;
    _classCallCheck(this, Dot);
    this.position = position;
    this.offset = offset;
    this.el = document.createElement('div');
    this.el.classList.add(_selectors.selectors.DOT);
    containerEl.appendChild(this.el);
    this.el.addEventListener('click', function () {
      return position.moveTo(_this.offset);
    });
  }
  return _createClass(Dot, [{
    key: "repaint",
    value: function repaint(newPosition) {
      if (this.offset === newPosition) {
        this.el.classList.add(_selectors.selectors.DOT_ACTIVE);
      } else {
        this.el.classList.remove(_selectors.selectors.DOT_ACTIVE);
      }
    }
  }]);
}();

},{"./selectors":7}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DotsFactory = void 0;
var _Dot = require("./Dot");
var _selectors = require("./selectors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DotsFactory = exports.DotsFactory = /*#__PURE__*/function () {
  function DotsFactory() {
    _classCallCheck(this, DotsFactory);
  }
  return _createClass(DotsFactory, null, [{
    key: "enabled",
    value: function enabled(dataStorageEl, position, totalSlides) {
      return new OnePerSlide(dataStorageEl, position, totalSlides);
    }
  }, {
    key: "disabled",
    value: function disabled() {
      return new Noop();
    }
  }]);
}();
var OnePerSlide = /*#__PURE__*/function () {
  function OnePerSlide(dataStorageEl, position, totalSlides) {
    _classCallCheck(this, OnePerSlide);
    this.position = position;
    this.dots = [];
    var containerEl = document.createElement('div');
    containerEl.classList.add(_selectors.selectors.DOTS);
    for (var i = 0; i < totalSlides; i++) {
      this.dots.push(new _Dot.Dot(containerEl, this.position, i));
    }
    dataStorageEl.insertAdjacentElement("afterend", containerEl);
  }
  return _createClass(OnePerSlide, [{
    key: "repaint",
    value: function repaint(newPosition) {
      this.dots.forEach(function (dot) {
        return dot.repaint(newPosition);
      });
    }
  }]);
}();
/**
 * When no dots are needed
 */
var Noop = /*#__PURE__*/function () {
  function Noop() {
    _classCallCheck(this, Noop);
  }
  return _createClass(Noop, [{
    key: "repaint",
    value: function repaint(newPosition) {}
  }]);
}();

},{"./Dot":2,"./selectors":7}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ElementsInView = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ElementsInView = exports.ElementsInView = /*#__PURE__*/function () {
  function ElementsInView(slidesEl) {
    _classCallCheck(this, ElementsInView);
    this.slidesEl = slidesEl;
  }
  return _createClass(ElementsInView, [{
    key: "count",
    value: function count() {
      var containerWidth = this.slidesEl.getBoundingClientRect().width;
      var slideWidth = this.slidesEl.children[0].getBoundingClientRect().width;
      var count = Math.floor(containerWidth / slideWidth);
      return count;
    }
  }]);
}();

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Position = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Position = exports.Position = /*#__PURE__*/function () {
  function Position(slidesCount, defaultPosition, allowInfinite, elementsInView) {
    _classCallCheck(this, Position);
    this.slidesCount = slidesCount;
    this.allowInfinite = allowInfinite;
    this.elementsInView = elementsInView;
    this.positionChangedSubscribers = [];
    this.currentPosition = defaultPosition;
  }
  return _createClass(Position, [{
    key: "moveToNext",
    value: function moveToNext() {
      var _this = this;
      if (this.currentPosition === this.getLastPosition()) {
        this.currentPosition = 0;
      } else {
        this.currentPosition++;
      }
      this.positionChangedSubscribers.forEach(function (subscriber) {
        return subscriber(_this.currentPosition);
      });
    }
  }, {
    key: "moveToPrevious",
    value: function moveToPrevious() {
      var _this2 = this;
      if (this.currentPosition === 0) {
        this.currentPosition = this.getLastPosition();
      } else {
        this.currentPosition--;
      }
      this.positionChangedSubscribers.forEach(function (subscriber) {
        return subscriber(_this2.currentPosition);
      });
    }
  }, {
    key: "moveTo",
    value: function moveTo(position) {
      var _this3 = this;
      if (position < 0 || position > this.slidesCount - 1) {
        throw new Error('Position out of range');
      }
      var lastPosition = this.getLastPosition();
      this.currentPosition = position > lastPosition ? lastPosition : position;
      this.positionChangedSubscribers.forEach(function (subscriber) {
        return subscriber(_this3.currentPosition);
      });
    }
  }, {
    key: "addPositionChangedSubscriber",
    value: function addPositionChangedSubscriber(callback) {
      this.positionChangedSubscribers.push(callback);
    }
  }, {
    key: "isAtFirst",
    value: function isAtFirst() {
      if (this.allowInfinite) {
        return false;
      }
      return this.currentPosition === 0;
    }
  }, {
    key: "isAtLast",
    value: function isAtLast() {
      if (this.allowInfinite) {
        return false;
      }
      var lastPosition = this.getLastPosition();
      return this.currentPosition >= lastPosition;
    }
  }, {
    key: "getLastPosition",
    value: function getLastPosition() {
      /**
       * slides	at once		last position
       * 5		1			4
       * 5		2			3
       * 5		3			2
       */
      var number = this.elementsInView.count();
      // todo make an expression instead of hardcoding
      switch (number) {
        case 1:
          return 4;
        case 2:
          return 3;
        case 3:
          return 2;
        default:
          throw new Error('Unsupported count of slides displayed at once');
      }
    }
  }]);
}();

},{}],6:[function(require,module,exports){
"use strict";

var _Position = require("./Position");
var _Dots = require("./Dots");
var _selectors = require("./selectors");
var _Autoplay = require("./Autoplay");
var _ElementsInView = require("./ElementsInView");
document.addEventListener('DOMContentLoaded', function () {
  return document.querySelectorAll('[data-references]').forEach(function (el) {
    return initialize(el);
  });
});
function initialize(rootEl) {
  var CarousePositionPropertyName = '--carouselPosition';
  var slidesEl = rootEl.querySelector('[data-references-slides]');
  var previousButtonEl = rootEl.querySelector('[data-references-button="previous"]');
  var nextButtonEl = rootEl.querySelector('[data-references-button="next"]');
  if (slidesEl === null || previousButtonEl === null || nextButtonEl === null) {
    return;
  }
  var slidesCount = slidesEl.children.length;
  var defaultPosition = parseInt(window.getComputedStyle(slidesEl).getPropertyValue(CarousePositionPropertyName));
  var allowInfinite = typeof rootEl.dataset.referencesInfinite !== 'undefined';
  var allowAutoplay = typeof rootEl.dataset.referencesAutoplay !== 'undefined';
  var noDots = typeof rootEl.dataset.referencesNoDots !== 'undefined';
  var elementsInView = new _ElementsInView.ElementsInView(slidesEl);
  var position = new _Position.Position(slidesCount, defaultPosition, allowInfinite, elementsInView);
  var dots = noDots ? _Dots.DotsFactory.disabled() // todo listen to elements in view, display only if count == 1
  : _Dots.DotsFactory.enabled(slidesEl, position, slidesCount);
  var autoplay = new _Autoplay.Autoplay(position);
  position.addPositionChangedSubscriber(function (newPosition) {
    slidesEl.style.setProperty(CarousePositionPropertyName, newPosition.toString());
    updateButtonVisibility();
    dots.repaint(newPosition);
  });
  previousButtonEl.addEventListener('click', function () {
    if (position.isAtFirst()) {
      return;
    }
    autoplay.disable();
    position.moveToPrevious();
  });
  nextButtonEl.addEventListener('click', function () {
    if (position.isAtLast()) {
      return;
    }
    autoplay.disable();
    position.moveToNext();
  });
  var updateButtonVisibility = function updateButtonVisibility() {
    previousButtonEl.classList.remove(_selectors.selectors.BUTTON_HIDDEN);
    nextButtonEl.classList.remove(_selectors.selectors.BUTTON_HIDDEN);
    if (position.isAtFirst()) {
      previousButtonEl.classList.add(_selectors.selectors.BUTTON_HIDDEN);
    }
    if (position.isAtLast()) {
      nextButtonEl.classList.add(_selectors.selectors.BUTTON_HIDDEN);
    }
  };
  // todo: resize, orientationchange
  // on init
  updateButtonVisibility();
  dots.repaint(defaultPosition);
  if (allowAutoplay) {
    autoplay.enable();
  }
}

},{"./Autoplay":1,"./Dots":3,"./ElementsInView":4,"./Position":5,"./selectors":7}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectors = void 0;
var selectors = exports.selectors = {
  BUTTON_HIDDEN: 'references__button--hidden',
  DOTS: 'references__dots',
  DOT: 'references__dot',
  DOT_ACTIVE: 'references__dot--active'
};

},{}]},{},[6]);
